/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePsychoDto } from '../../models/create-psycho-dto';
import { ResponsePsychoDto } from '../../models/response-psycho-dto';

export interface PsychosControllerCreate$Params {
      body: CreatePsychoDto
}

export function psychosControllerCreate(http: HttpClient, rootUrl: string, params: PsychosControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePsychoDto>> {
  const rb = new RequestBuilder(rootUrl, psychosControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponsePsychoDto>;
    })
  );
}

psychosControllerCreate.PATH = '/thalea-psychos/psychos';
